import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils";
import React from "react";
import useFramerMotion, { LazyMotion, m } from "@/hooks/useFramerMotion";
export const Meteors = t0 => {
  const $ = _c(6);
  const {
    number,
    className
  } = t0;
  const meteors = new Array(number || 20).fill(true);
  const framerMotionFeatures = useFramerMotion();
  const T0 = LazyMotion;
  let t1;
  if ($[0] !== className) {
    t1 = (el, idx) => <m.span key={"meteor" + idx} className={cn("absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] animate-meteor-effect rounded-[9999px] bg-accent-300/60 motion-reduce:animate-none", "before:absolute before:top-1/2 before:h-[1px] before:w-[50px] before:-translate-y-[50%] before:transform before:bg-gradient-to-r before:from-accent/50 before:to-transparent before:content-['']", className)} style={{
      top: Math.floor(Math.random() * 1800 + -400) + "px",
      left: Math.floor(Math.random() * 1800 + -400) + "px",
      animationDelay: Math.random() * 0.6000000000000001 + 0.2 + "s",
      animationDuration: Math.floor(Math.random() * 13 + 2) + "s"
    }} />;
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = meteors.map(t1);
  let t3;
  if ($[2] !== T0 || $[3] !== framerMotionFeatures || $[4] !== t2) {
    t3 = <><T0 features={framerMotionFeatures}>{t2}</T0></>;
    $[2] = T0;
    $[3] = framerMotionFeatures;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};